var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0406 3.29289C4.65008 2.90237 4.01691 2.90237 3.62639 3.29289C3.23586 3.68342 3.23586 4.31658 3.62639 4.70711L6.05055 7.13127C4.61989 8.20737 3.37275 9.68543 2.43907 11.5528C2.29831 11.8343 2.29831 12.1657 2.43907 12.4472C4.59729 16.7637 8.43037 19 12.3335 19C13.8886 19 15.4327 18.645 16.8641 17.9448L19.6264 20.7071C20.0169 21.0976 20.6501 21.0976 21.0406 20.7071C21.4311 20.3166 21.4311 19.6834 21.0406 19.2929L5.0406 3.29289ZM15.3473 16.428C14.3678 16.8112 13.3469 17 12.3335 17C9.36471 17 6.33155 15.3792 4.46315 12C5.28071 10.5214 6.32127 9.3794 7.48187 8.56259L9.62587 10.7066C9.43845 11.0982 9.3335 11.5369 9.3335 12C9.3335 13.6569 10.6766 15 12.3335 15C12.7966 15 13.2353 14.8951 13.6269 14.7076L15.3473 16.428Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8858 13.8955C19.3688 13.3402 19.8119 12.7088 20.2038 12C18.3354 8.62078 15.3022 7 12.3335 7C12.2215 7 12.1094 7.00231 11.9972 7.00693L10.2129 5.22258C10.9109 5.07451 11.621 5 12.3335 5C16.2366 5 20.0697 7.23635 22.2279 11.5528C22.3686 11.8343 22.3686 12.1657 22.2279 12.4472C21.6839 13.5352 21.0335 14.491 20.3024 15.3121L18.8858 13.8955Z",
    fill: "#6E6E6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.9c8d6ad3fec99e0a900c53ddacfe8968.svg";
export { ForwardRef as ReactComponent };